import { WIKI_API_BASE_URL } from "components/Constants";

export const WIKI_ARTICLES_URL = WIKI_API_BASE_URL + '/articles/'
export const WIKI_TAGS_URL = WIKI_API_BASE_URL + '/tags/'

export const STENO_FONT_FAMILY_OPTS = [
  { name: "Open Sans", value: "Open Sans" },
  { name: "Poppins", value: "Poppins" },
];
